import type { ProjectScope } from './project-scope';

const pendingAttendanceRecordWriteKeys = new Set<string>();
const pendingAttendanceActorWriteKeys = new Set<string>();

function attendanceRecordWriteKey(scope: ProjectScope, eventId: string): string {
    return `${scope.orgId}\0${scope.projectId}\0${eventId}`;
}

function attendanceActorWriteKey(scope: ProjectScope, eventId: string, actorId: string): string {
    return `${attendanceRecordWriteKey(scope, eventId)}\0actors\0${actorId}`;
}

function attendanceActorWritePrefix(scope: ProjectScope, eventId: string): string {
    return `${attendanceRecordWriteKey(scope, eventId)}\0actors\0`;
}

export function markPendingAttendanceRecordWrite(scope: ProjectScope, eventId: string): void {
    pendingAttendanceRecordWriteKeys.add(attendanceRecordWriteKey(scope, eventId));
}

export function clearPendingAttendanceRecordWrite(scope: ProjectScope, eventId: string): void {
    pendingAttendanceRecordWriteKeys.delete(attendanceRecordWriteKey(scope, eventId));
}

export function isPendingAttendanceRecordWrite(scope: ProjectScope, eventId: string): boolean {
    return pendingAttendanceRecordWriteKeys.has(attendanceRecordWriteKey(scope, eventId));
}

export function markPendingAttendanceActorWrite(scope: ProjectScope, eventId: string, actorId: string): void {
    pendingAttendanceActorWriteKeys.add(attendanceActorWriteKey(scope, eventId, actorId));
}

export function clearPendingAttendanceActorWrite(scope: ProjectScope, eventId: string, actorId: string): void {
    pendingAttendanceActorWriteKeys.delete(attendanceActorWriteKey(scope, eventId, actorId));
}

export function isPendingAttendanceActorWrite(scope: ProjectScope, eventId: string, actorId: string): boolean {
    return pendingAttendanceActorWriteKeys.has(attendanceActorWriteKey(scope, eventId, actorId));
}

export function pendingAttendanceActorIds(scope: ProjectScope, eventId: string): string[] {
    const prefix = attendanceActorWritePrefix(scope, eventId);
    return Array.from(pendingAttendanceActorWriteKeys)
        .filter((key) => key.startsWith(prefix))
        .map((key) => key.slice(prefix.length));
}

export function clearPendingAttendanceWrites(): void {
    pendingAttendanceRecordWriteKeys.clear();
    pendingAttendanceActorWriteKeys.clear();
}
